import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PureFnPipe } from './pure-fn.pipe';

@NgModule({
  declarations: [PureFnPipe],
  imports: [CommonModule],
  exports: [PureFnPipe]
})
export class PureFnModule {}
